module.exports = __webpack_public_path__ + "static/img/animation-index5.3e38e57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/animation-index5.png
// module id = C6uO
// module chunks = 4